<template>
  <div
    class="col-lg-4 mb-3 mb-md-1 mb-lg-3"
    :class="{ selected: isServiceGroupEnabled}"
    data-toggle="tooltip"
    :title="toolTipMessage"
    :data-service-group-id="serviceGroup.service_group_id"
  >
    <div class="card card-selectable card-saved" :class="{'card-selected' : isServiceGroupEnabled}" v-bind:style="serviceCardStyle"  tabindex="0" @keydown="selectServiceGroupKeyEvent">
      <div class="card-body card-body--forservice p-4">
        <!-- <ColorFilter> -->
          <img class="icon" :src="pubPath + serviceGroup.image" v-error-img-load />
        <!-- </ColorFilter> -->
        <span class="pl-3">{{serviceGroup.group_name}}</span>
      </div>
      <div
        v-show="serviceGroup.service_group_id == selectedServiceGroupId"
        class="card-body-selected"
        :style="'background-color:' + MainUISettings.button_color"
      >
        <i class="icon-check"></i>
      </div>
      <div
        v-show="!isServiceGroupEnabled && savedSelectedService > 0"
        class="card-body-saved"
        :style="'background-color:' + MainUISettings.button_color"
      >
        <span class="card-body-saved__count skiptranslate">{{savedSelectedService}}</span>
        <span class="icon-simple icon-simple--circle icon-simple--bordered icon-simple--minus icon-simple--bordered--primary" @click="clearBookingServiceGroup($event)"></span>here
      </div>
    </div>
  </div>
</template>

<script>

import ColorFilter from '../../../../common/components/ColorFilter';

export default {
  components: {
    ColorFilter
  },
  data(){
    return {
      pubPath: process.env.MIX_APP_URL,
    }
  },
  props: {
    serviceGroup: Object,
    selectedServiceGroupId: Number
  },
  computed: {
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    isServiceGroupEnabled() {
      return this.serviceGroup.service_group_id == this.selectedServiceGroupId;
    },

    toolTipMessage() {
      // Why is this here -- Franco
      var wrongMessage = "This service is not available for your address";
      return "";
    },

    serviceCardStyle() {
      var buttonColor = this.$store.getters["GET_MAIN_UI"].button_color;

      return this.isServiceGroupEnabled
        ? {
            border: "1px solid " + buttonColor,
            'border-color' : buttonColor + '!important',
            "background-color": this.convertHex(buttonColor)
          }
        : null;
    },
    
    savedSelectedService() {
      // Get Products by Service Group. Then Group by Service Setting ID
      const serviceSettings = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
        .filter(product => product.service_group_id === this.serviceGroup.service_group_id)
        .reduce((r, a) => {
         r[a.service_setting_id] = [...r[a.service_setting_id] || [], a];
         return r;
        }, {});

      // Count of unique Service Setting IDs
      return Object.keys(serviceSettings).length;
    }
  },
  methods:{
        convertHex(color) {
            color = color.replace('#', '')
            let r = parseInt(color.substring(0, 2), 16)
            let g = parseInt(color.substring(2, 4), 16)
            let b = parseInt(color.substring(4, 6), 16)
            let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.05 + ')'
            return result
        },
    selectServiceGroupKeyEvent(event){
      if (event.keyCode == 32 || event.keyCode == 13) {
        event.preventDefault();
        this.$emit('keyEvent')
      }
    },
    clearBookingServiceGroup(event) {
      let service_group_id = this.serviceGroup.service_group_id;
      this.$parent.$emit('showConfirmClearGroup', {
        service_group_id
      });
      event.preventDefault();
      event.stopPropagation();
    }
  }
};
</script>